module.exports = __webpack_public_path__ + "static/media/caret-circle-up.985f2881.svg";